const validatePhoneNumber = (value, type) => {
  if(!value || !type) return;
  const { areaCode, number } = value;

  let numberValue = number.replace(/[^0-9]/g, '');
  let areaCodeValue = areaCode.replace(/[^0-9]/g, '');

  let regex;
  let valueTest;

  switch (type) {
    case 'MOBILE':
      valueTest = `(${areaCodeValue}) ${numberValue.slice(0,5)}-${numberValue.slice(5)}`;
      regex = /^\([1-9][0-9]{1,2}\) (?:[2-8]|9[0-9])[0-9]{3}\-[0-9]{4}$/;
      break;
    case 'HOME':
      valueTest = `${areaCodeValue}${numberValue}`;
      
      regex = /^[1-9][0-9]{1,2}(9)?[2-9][0-9]{3}[0-9]{4}$/;

      break;

    case 'WORK':
      valueTest = `${areaCodeValue}${numberValue}`;
      regex = /^[1-9][0-9]{1,2}(9)?[2-9][0-9]{3}[0-9]{4}$/;
      break;
    default:
      return false;
  }
  return regex.test(valueTest);
};

export default validatePhoneNumber;
